<template>
  <div>
    <a-select
      :not-found-content="loading ? '加载中...' : '无数据'"
      v-model="selectedValue"
      :placeholder="placeholder"
      @search="onSearch"
      @change="onChange"
      @clear="onClear"
      allow-clear
      :filter-option="false"
      :show-search="true"
      :disabled="disabled" style="width: 100%;min-width: 200px;"
    >
      <a-select-option
        v-for="(item, index) in userList"
        :key="`user-${item.userCode}-${index}`"
        :value="item.userCode"
        :title="`${item.userName}（${item.userCode}）`"
      >
        <div class="user-option-content">
          <span class="user-name">{{ item.userName }}</span>
          <span class="user-code">（{{ item.userCode }}）</span>
        </div>
      </a-select-option>
    </a-select>
  </div>
</template>

<script>
export default {
  name: 'UserSelect',
  props: {
    value: {
      type: [String, Number],
      default: ''
    },
    placeholder: {
      type: String,
      default: '请输入用户名称/编码搜索'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    showDebug: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      userList: [],
      loading: false,
      searchTimer: null
    }
  },
  computed: {
    selectedValue: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    // 搜索用户
    onSearch(value) {
      console.log('用户搜索关键词:', value);
      
      if (!value || value.length < 2) {
        this.userList = []
        return
      }
      
      // 防抖处理
      if (this.searchTimer) {
        clearTimeout(this.searchTimer)
      }
      
      this.searchTimer = setTimeout(() => {
        this.loading = true
        this.$http.get(`/meter-manager/users/fuzzy-search`, {
          params: { keyword: value }
        })
          .then(({ data }) => {
            console.log('用户搜索返回数据:', data);
            
            // 确保data是数组格式
            let userData = []
            if (Array.isArray(data)) {
              userData = data
            } else if (data && Array.isArray(data.list)) {
              userData = data.list
            } else if (data && Array.isArray(data.data)) {
              userData = data.data
            } else {
              console.warn('用户数据格式不正确:', data);
              userData = []
            }
            
            // 验证并过滤用户数据
            this.userList = this.validateUserData(userData) || []
            
            console.log('处理后的用户列表:', this.userList);
            this.loading = false
          })
          .catch((error) => {
            console.error('用户搜索失败:', error);
            this.loading = false
            this.userList = []
          })
      }, 300) // 300ms 防抖
    },
    
    // 用户选择变化
    onChange(value) {
      console.log('用户选择变化:', value);
      const user = this.userList.find((u) => u.userCode === value)
      
      // 触发change事件，传递选中的用户信息
      this.$emit('change', value, user)
    },
    
    // 清空选择
    onClear() {
      console.log('清空用户选择');
      this.userList = []
      this.$emit('change', '', null)
    },
    
    // 验证用户数据格式
    validateUserData(userData) {
      if (!Array.isArray(userData)) {
        console.warn('用户数据不是数组格式:', userData);
        return false;
      }
      
      // 检查每个用户对象是否包含必要的字段
      const validUsers = userData.filter(user => {
        if (!user || typeof user !== 'object') {
          console.warn('用户数据项不是对象:', user);
          return false;
        }
        
        if (!user.userCode || !user.userName) {
          console.warn('用户数据缺少必要字段:', user);
          return false;
        }
        
        return true;
      });
      
      if (validUsers.length !== userData.length) {
        console.warn(`过滤掉 ${userData.length - validUsers.length} 个无效用户数据`);
      }
      
      return validUsers;
    },
    
    // 清空用户列表
    clearUserList() {
      this.userList = []
    }
  },
  
  beforeDestroy() {
    // 清理定时器
    if (this.searchTimer) {
      clearTimeout(this.searchTimer)
    }
  }
}
</script>

<style>
.user-option-content {
  display: flex !important;
  align-items: center !important;
  width: 100% !important;
  max-width: 280px !important;
}

.user-name {
  flex: 1 !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
  margin-right: 8px !important;
  max-width: 200px !important;
}

.user-code {
  flex-shrink: 0 !important;
  color: #666 !important;
  font-size: 12px !important;
}

/* 下拉菜单容器样式 */
:deep(.ant-select-dropdown) {
  min-width: 320px !important;
  max-width: 400px !important;
}

:deep(.ant-select-dropdown-menu-item) {
  padding: 8px 12px !important;
  white-space: nowrap !important;
  height: auto !important;
  overflow: hidden !important;
}

:deep(.ant-select-dropdown-menu-item .user-option-content) {
  display: flex !important;
  align-items: center !important;
  width: 100% !important;
}

:deep(.ant-select-dropdown-menu-item .user-name) {
  flex: 1 !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
  max-width: 220px !important;
}

:deep(.ant-select-dropdown-menu-item .user-code) {
  flex-shrink: 0 !important;
  margin-left: 8px !important;
}
</style> 